import { React, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import "../Style/Navbar.scss";
import $ from "jquery";
import VisibilitySensor from "react-visibility-sensor";

const navItems = [
  { id: "about", label: "About", type: "section" },
  { id: "team", label: "Our Team", type: "section" },
  { id: "vision", label: "Vision", type: "section" },
  { id: "history", label: "History", type: "section" },
  { id: "why-join", label: "Why Join", type: "section" },
  { id: "objectives", label: "Objectives", type: "section" },
  { id: "gallery", label: "Gallery", type: "section" },
  { id: "events", label: "Events", type: "route", path: "/events" },
  { id: "contact", label: "Contact", type: "section" },
];

function Navbar() {
  const [activeSection, setActiveSection] = useState("about");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    // Only run scroll spy on home page
    if (location.pathname !== "/") return;

    // Scroll spy to highlight active section
    const handleScroll = () => {
      const sectionItems = navItems.filter(item => item.type === "section");
      const sections = sectionItems.map(item => document.getElementById(item.id));
      const scrollPosition = window.scrollY + 150;

      for (let i = sections.length - 1; i >= 0; i--) {
        const section = sections[i];
        if (section && section.offsetTop <= scrollPosition) {
          setActiveSection(sectionItems[i].id);
          break;
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [location.pathname]);

  const handleNavClick = (item) => {
    if (item.type === "route") {
      // Navigate to route
      history.push(item.path);
      setActiveSection(item.id);
    } else {
      // Scroll to section
      if (location.pathname !== "/") {
        // If not on home page, navigate to home first then scroll
        history.push("/");
        setTimeout(() => {
          scrollToSection(item.id);
        }, 100);
      } else {
        scrollToSection(item.id);
      }
    }
    setIsMenuOpen(false);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const navbarHeight = 80;
      const elementPosition = element.offsetTop - navbarHeight;
      
      window.scrollTo({
        top: elementPosition,
        behavior: "smooth",
      });
    }
  };

  function onChange(isVisible) {
    !isVisible
      ? $(".navbar").addClass("fixed-top")
      : $(".navbar").removeClass("fixed-top");
  }

  return (
    <div className="Navbar">
      <VisibilitySensor onChange={onChange} scrollCheck={true}>
        <div
          className="d-flex justify-content-center align-items-center p-2"
          id="header"
        >
          <img
            src="https://res.cloudinary.com/unesco-admin/image/upload/v1686730963/Logopit_1686414165618_bzzoz9_o2yiqp.png"
            alt="logo2"
            id="logo2"
            onClick={() => {
              window.location.assign("/");
            }}
          />
          <div className="clgHeading">
            <h2 id="clgName">
              GLOBAL NETWORK OF BIOETHICS, MEDICAL AND HEALTH PROFESSIONS EDUCATION, <br></br>MELBOURNE, AUSTRALIA
            </h2>
          </div>
        </div>
      </VisibilitySensor>

      {/* Navbar */}
      <nav className="navbar navbar-light bg-light">
        <div className="nav-container">
          <button
            className={`navbar-toggler ${isMenuOpen ? 'open' : ''}`}
            type="button"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-controls="navbarNav"
            aria-expanded={isMenuOpen}
            aria-label="Toggle navigation"
          >
            <span className="toggler-line"></span>
            <span className="toggler-line"></span>
            <span className="toggler-line"></span>
          </button>
          
          <ul className={`nav-menu ${isMenuOpen ? 'open' : ''}`}>
            {navItems.map((item) => (
              <li className="nav-item" key={item.id}>
                <span
                  className={`nav-link ${
                    item.type === "route" 
                      ? location.pathname === item.path ? 'active' : ''
                      : activeSection === item.id && location.pathname === "/" ? 'active' : ''
                  }`}
                  onClick={() => handleNavClick(item)}
                >
                  {item.label}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
